// extracted by mini-css-extract-plugin
module.exports = {"radio":"Radio_radio__3p4LV","input":"Radio_input__2FWVL","inner":"Radio_inner__1hEgU","tick":"Radio_tick__apBbR","text":"Radio_text__2pqAv"};